import * as React from "react";

interface Props {
    values: any[],
    name?: string,
    radioClassname?: string,
    labelClassname?: string,
    size?: string,
    list?: boolean,
    value?: any,
    onChange?: any
}

interface State {
    value?: any
}

export default class FormRadio extends React.Component<Props, State> {
    name: string;

    constructor(props) {
        super(props);
        this.name = this.getName();

        this.state = {
            value: this.props.value
        }
    }

    getName() {
        if(this.props.name)
            return this.props.name;

        let rnd = Math.floor(Math.random() * 999999) + 1;

        return "form-radio-" + rnd;
    }

    onChange(e) {
        if(this.props.onChange) 
            this.props.onChange(this.name, e.target.value);

        this.setState({
            value: e.target.value
        });
    }

    renderSequence(item) {
        return (
            <label className="radio-inline" key={item.key}>
                <input type="radio" name={this.name} id={this.name + "-" + item.key} 
                    value={item.key} checked={this.state.value == item.key} 
                    onChange={(event) => this.onChange(event)} />{item.value}
                <span className={"checkmark"}></span>
            </label>
        )
    }

    renderList(item) {

        const labelClassname = (this.props.labelClassname == null || this.props.labelClassname == undefined) ?
            '' :
            `${this.props.labelClassname}`;

        return (
            <label className={labelClassname} style={{ display: "grid" }} key={item.key}>
                <input type="radio" name={this.name} id={this.name + "-" + item.key} 
                    value={item.key} checked={this.state.value == item.key} 
                    onChange={(event) => this.onChange(event)} />{item.value}
                <span className={"checkmark"}></span>
            </label>
        )
    }

    render() {

        let style = (this.props.name === 'sesso') ? {
            position: 'relative',
            top: '-15px',
            fontFamily: "'Open Sans', sans-serif",
            fontSize: '13px',
            fontWeight: 'normal'
        } : {
            position: 'relative',
            top: '-15px',
        } as any;

        const radioClassname = (this.props.radioClassname == null || this.props.radioClassname == undefined) ?
            'custom-radio' :
            `custom-radio ${this.props.radioClassname}`;

        return (
             <div className={radioClassname} style={{fontSize: this.props.size }}>
                 <span style={style}>{ this.props.children }</span>
                {   !this.props.list &&
                        this.props.values.map((item) => this.renderSequence(item))
                }
                 {   this.props.list &&
                    this.props.values.map((item) => this.renderList(item))
                 }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ui/FormRadio.tsx